import { createChatMessage } from 'shared/panda/messages/panda-chat-message';
import { UserMessage } from './user-message';
import { AssistantMessage } from './assistant-message';
import { ProgressLoader } from '../progress-loader/progress-loader';

export const ChatMessage = createChatMessage({ UserMessage, AssistantMessage, ProgressLoader });
